import barrie from './cities/barrie'
import burlington from './cities/burlington'
import guelph from './cities/guelph'
import hamilton from './cities/hamilton'
import kitchener from './cities/kitchener'
import london from './cities/london'
// import niagaraFalls from './cities/niagaraFalls'
import ottawa from './cities/ottawa'
// import stCatharines from './cities/stCatharines'
import thunderBay from './cities/thunderBay'

export default {
  province: 'Ontario',
  abbr: 'Ont.',
  alpha: 'ON',
  lawSociety: 'Law Society of Upper Canada',
  writeup: '',
  cities: [
    barrie,
    burlington,
    guelph,
    hamilton,
    kitchener,
    london,
    ottawa,
    thunderBay
  ]
}



// WEBPACK FOOTER //
// ./src/store/provinces/ontario/index.js